export default __webpack_public_path__ + "b1e0838cc234004bc4d914475fd43380.png";